import { Dimensions, StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';
import { IS_ANDROID } from '@/utils/platform';
const SCREEN_HEIGHT = Dimensions.get('window').height;

export const styles = StyleSheet.create({
  sideBar: {
    flex: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    paddingVertical: 10,
    width: '100%',
  },
  userBox: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: theme.spacings['3xl'],
    paddingHorizontal: theme.spacings.lg,
    paddingRight: 45,
    paddingVertical: theme.spacings.sm,
    gap: theme.spacings.md,
  },
  userImg: {
    width: 36,
    height: 36,
  },
  tagsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacings.xs,
  },
  therapistTag: {
    borderWidth: 0,
  },
  patientTagLabel: {
    fontSize: theme.fontSizes.xs,
  },
  blurOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  buttonWrapper: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: 70,
    paddingBottom: 18,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: theme.spacings.md,
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.lg,
  },
  noPatientWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: SCREEN_HEIGHT * 0.7,
  },
  welcomeTextMain: {
    textAlign: 'center',
    marginTop: 20,
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
  },
  welcomeTextSubMain: {
    textAlign: 'center',
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
    paddingBottom: 20,
  },
  iconImageWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  iconStyle: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderRadius: 50,
    padding: 10,
    position: 'absolute',
  },
  subTextMain: {
    textAlign: 'center',
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
    paddingTop: 20,
  },
  subTextSubMain: {
    textAlign: 'center',
    color: colors.newUI.therapist.blue90,
    paddingBottom: 20,
  },
  noFilteredPatients: {
    alignItems: 'center',
    paddingVertical: theme.spacings.xl,
  },
  noFilteredPatientsTitle: {
    fontSize: theme.fontSizes.lg,
    fontWeight: '600',
    color: colors.newUI.therapist.grey60,
    marginBottom: theme.spacings.sm,
    textAlign: 'center',
  },
  noFilteredPatientsSubtitle: {
    fontSize: theme.fontSizes.base,
    color: colors.newUI.therapist.grey60,
    textAlign: 'center',
  },
  profileColor: {
    height: 45,
    width: 45,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileInitials: {
    fontSize: 18,
    letterSpacing: 3,
    marginRight: IS_ANDROID ? 0 : -3,
    textAlign: 'center',
    includeFontPadding: false,
  },
});
